export const stripePk = "pk_test_51MCq0PFOcmGi03pewBhGFQJlPZObz9xajeJhBEd4uONGsItPjax4MGX7GuQ36buxZ3et6v7qDzgOnWks4I28ZC4500Ewn7jqKu";
export const stripeBackendUri = "https://us-central1-watchdogger-pr2.cloudfunctions.net/stripeBackend";
export const functionLocation = "us-central1"

